const { Box } = require("@mui/material");
const { styled } = require("@mui/system");

const Bucket = styled(Box)({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
    backgroundColor: 'white',
    borderRadius: '30px',
    // height: '160px',
    padding: '10px',
    borderTop: '3px solid #0066b2',
    borderBottom: '3px solid #0066b2'
});

export default Bucket;